export default "__VITE_ASSET__BAVdPH3N__"